<template>
  <div>
    <div v-if="show_form" style="text-align: right;" dir="rtl">
      <div>
        <p class="bold">Title</p>
        <input class="outlined" v-model="title">
      </div>
      <div>
        <p class="bold">Content</p>
        <textarea class="outlined" v-model="content"></textarea>
      </div>
    </div>
    <div class="modal_footer">
      <a
        @click="submit()"
        :class="{ 'is-loading': is_loading }"
        class="button is-info"
        >Submit</a
      >
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { mapMutations } from 'vuex'
export default {
  props: ['payload'],
  name: 'developer-interview-articles',
  data () {
    return {
      is_loading: false,
      show_form: false,
      title: '',
      content: ''
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      if (this.payload.is_create) {
        this.show_form = true
        return
      }
      axios.request({
        method: 'get',
        url: `http://64.225.73.88:9078/articles/${this.payload.data.id}`
      }).then(response => {
        this.title = response.data.title
        this.content = response.data.content
        this.show_form = true
      })
    },
    submit () {
      let method = this.payload.is_create ? 'post' : 'put'
      axios.request({
        method,
        url: `http://64.225.73.88:9078/articles/${this.payload.is_create ? '' : this.payload.data.id}`,
        data: {
          title: this.title,
          content: this.content
        }
      }).then(() => {
        this.remove(this.payload)
      })
    },
    ...mapMutations('modals', ['remove'])
  }
}
</script>
